export const PosterReferences = ({ entry }) => (
  <section className="poster-section poster-sources" aria-labelledby="poster-sources-title">
    <h3 id="poster-sources-title">Sources and further reading</h3>
    <ol data-testid="poster-source-links">{entry.sources.map((source, i) => <li id={`poster-reference-${i + 1}`} key={`${entry.id}-${i}-${source.url}`} data-testid={`poster-reference-${i}`}>
      <span data-testid={`poster-source-label-${i}`}>[{i + 1}] {source.type} · {source.label}</span>
      <a href={source.url} target="_blank" rel="noopener noreferrer" data-testid={`poster-source-${i}`}>{source.url}</a>
    </li>)}</ol>
  </section>
);